
























































































import { Component, Prop, Vue } from 'vue-property-decorator';
import AlpacaBtn from '@/components/AlpacaBtn.vue';
import WearableCard from '@/components/WearableCard.vue';
import SelectScarfPopup from '@/components/SelectScarfPopup.vue';
import {Wearable} from '@/backend/type';
import {getScarfInfo} from '@/backend/requests';
import {wearableInfo} from '@/utils/wearable';
import BigNumber from 'bignumber.js';
import { isApprovedForAll, setApprovalForAll } from '@/contract/wearable';
import { userInfo, pendingAlpa, stake, unstake, claim } from '@/contract/wearableReward';
import { EventBus } from '@/utils/EventBus';

@Component({
  components: {
    AlpacaBtn,
    WearableCard,
    SelectScarfPopup,
  },
})
export default class ScarfFarm extends Vue {
  public alpaEarned: string = '0';
  public showSelectPopup: boolean = false;
  public userWearableInfo: {weeklyReward: BigNumber; percentage: BigNumber} | null = null;

  public choosingFarmer: Wearable | null = null;
  public curFarmer: Wearable | null = null;
  public isApprovedForStake: boolean = false;
  public approveLoading: boolean = false;

  get account() {
    return this.$store.getters.getAccount;
  }

  get weeklyReward() {
    if (this.userWearableInfo) {
      return this.$options.filters!.fixedAndComma(this.userWearableInfo.weeklyReward, 2);
    }
    return '-';
  }

  get percentage() {
    if (this.userWearableInfo) {
      return this.$options.filters!.fixedAndComma(this.userWearableInfo.percentage, 2);
    }
    return '-';
  }

  public mounted() {
    this.getAlpaEarned();
    this.getWearableInfo();
    this.getIsApprovedForAll();
    this.getCurFarmer();
    EventBus.$on('approve-status', this.onApproveStatus);
  }

  public beforeDestroy() {
    EventBus.$off('approve-status', this.onApproveStatus);
  }

  public async onApproveStatus(status: 'approving' | 'completed' | 'error') {
      if (status === 'completed') {
        this.getIsApprovedForAll();
        this.approveLoading = false;
      }
      if (status === 'error') {
        this.approveLoading = false;
      }
    }

  public async getAlpaEarned() {
    const amount = await pendingAlpa(this.account);
    if (amount) {
      this.alpaEarned = amount;
    }
  }

  public async getWearableInfo() {
    const res = await wearableInfo(this.account);
    if (res) {
      this.userWearableInfo = res;
    }
  }

  public async getIsApprovedForAll() {
    const res = await isApprovedForAll(process.env.VUE_APP_WEARABLE_REWARD_CONTRACT_ADDRESS!, this.account);
    if (res) {
      this.isApprovedForStake = res;
    }
  }

  public async getCurFarmer() {
    const res = await userInfo(this.account);
    if (res && res.wearableID !== '0') {
      const id = res.wearableID;
      const info = await getScarfInfo(id);
      if (info) {
        this.curFarmer = info.data;
      }
    }
  }

  public handleClaim() {
    claim(this.account);
  }

  public handleApprove() {
    this.approveLoading = true;
    setApprovalForAll(process.env.VUE_APP_WEARABLE_REWARD_CONTRACT_ADDRESS!, this.account);
  }

  public handleFire() {
    unstake(this.account);
  }

  public clickWearableCard(wearable: Wearable) {
    this.choosingFarmer = wearable;
  }

  public toggleSelectPopup() {
    if (!this.isApprovedForStake) {
      return;
    }
    this.showSelectPopup = !this.showSelectPopup;
  }

  public confirmFarmer() {
    if (!this.choosingFarmer) {
      return;
    }
    stake(this.account, Number(this.choosingFarmer.id));
  }
}
